module.exports = __webpack_public_path__ + "static/outline-headings-471d7df35a7c117c25f87bdee9b67768.png";